module.exports = __webpack_public_path__ + "prod/1.42.2/img/icon-phone-white.a4d5752f.svg";